module.exports = __webpack_public_path__ + "img/zavalishina.ccc51796.jpg";